import withStyles from '@mui/styles/withStyles';
import Radio from '@mui/material/Radio';
// import { Auth } from 'aws-amplify';
import { calendarNames } from '../SettingsSyncToCal/SettingsSyncToCalHelper';

export const shareEventsColumns = {
  all: true,
  pairings: true,
  dayOff: true,
  displacedPairings: true,
  GDOs: true,
  pairingBiddingDates: true,
  reserve: true,
  reassignmentPeriods: true,
  sdoSubmissionDates: true,
  sickDays: true,
  trainingEvents: true,
  simRequestDates: true,
  artRequestDates: true
};

export const getCalendarType = (data) => {
  switch (true) {
    case data.googleFlag === true:
      return calendarNames.GOOGLE;
    case data.iOSFlag === true:
      return calendarNames.APPLE;
    case data.outlookFlag === true:
      return calendarNames.OUTLOOK;
    default:
      return ' ';
  }
};

export const getEmailAddFont = (email) => {
  if (email.length >= 23) return 'sync-add-account__cntr-long-email-address';
  else return 'sync-add-account__cntr-email-address';
};

export const fields = [
  { field: 'all', headerName: 'All' },
  { field: 'pairings', headerName: 'Pairings' },
  { field: 'reserve', headerName: 'RSV/RAP/RAP-H' },
  { field: 'trainingEvents', headerName: 'Training Events' },
  { field: 'reassignmentPeriods', headerName: 'Reassignment Periods' },
  { field: 'displacedPairings', headerName: 'Displaced Pairings' },
  { field: 'GDOs', headerName: 'Reserve Days Off' },
  { field: 'dayOff', headerName: 'Days Off (VAC & SDO)' },
  { field: 'sickDays', headerName: 'Sick Events' },
  { field: 'pairingBiddingDates', headerName: 'Pairing & Bidding Dates' },
  { field: 'sdoSubmissionDates', headerName: 'SDO Submission Dates' },
  { field: 'simRequestDates', headerName: 'SIM Request Dates' },
  { field: 'artRequestDates', headerName: 'ART Request Dates' }
];

export const getAccountType = (data) => {
  switch (true) {
    case data.googleFlag === true:
      return 'google';
    case data.iOSFlag === true:
      return 'apple';
    case data.outlookFlag === true:
      return 'outlook';
    default:
      return ' ';
  }
};

export const StyledRadio = withStyles({
  root: {
    color: '#97999c',
    '&$checked': {
      color: '#005078'
    },
    '& .MuiSvgIcon-root': {
      fontSize: 28
    }
  },
  checked: {}
})(Radio);

export const getEventsContent = (events) => {
  const filter = Object.fromEntries(
    Object.entries(events).filter(([key, value]) => value !== false)
  );
  if (Object.keys(filter).length === 0) return true;
  else return false;
};

/**
 * Checks if account has any error linked to re-authentication.
 * @function
 * @param {Object} account - acount object
 * @returns {Boolean} : True if no 401 errorCode,  false if account does not require re-authentication
 */
export const isReAuthenticationReqd = (account) => {
  const errorCode = parseInt(account?.errorCode);
  return errorCode === 401 || errorCode === 400 || errorCode === 403;
};

/**
 * Returns array of NickNames from synced accounts
 * @function
 * @param {Array} account - Array of account object
 * @returns {Array} : Array of string nick names
 */
export const getNickNamesFromAccounts = (accounts) => {
  return accounts?.length
    ? accounts.map((oData) => {
        const emailObj = oData['emailId'];
        return (
          emailObj && oData[emailObj] && oData[emailObj]['accountNickName']
        );
      })
    : [];
};

export const VALIDATIONCODES = {
  INVALIDID: 5009,
  IDALREADYEXISTS: 5008
};

/**
 * Returns Object of calendar types as keys and emailIds as values
 * @function
 * @param {Array} account - Array of account object
 * @returns {Object} : Object {google : [], apple: [], outlook: []}
 */
export const getAvailableEmailIdsFromAccounts = (accounts) => {
  // default initialization
  const availableAccs = {
    google: [],
    apple: [],
    outlook: []
  };

  if (accounts?.length) {
    accounts.forEach((acc) => {
      availableAccs[acc.accountType] = availableAccs[acc.accountType] || [];
      availableAccs[acc.accountType].push(acc['emailId'].toLowerCase());
    });
  }
  return availableAccs;
};

export const getErrorData = (errorCode) => {
  if (errorCode) return errorCode;
  else return VALIDATIONCODES.IDALREADYEXISTS;
};

export const inputTextValidation = (value) => {
  if (!value) return;
  for (let index = 0; index < value.length; index++) {
    const cc = value.charCodeAt(index);
    if (
      !(cc > 47 && cc < 58) &&
      !(cc > 64 && cc < 91) &&
      !(cc > 94 && cc < 123) &&
      !(cc === 33) &&
      !(cc === 35) &&
      !(cc === 39) &&
      !(cc === 45) &&
      !(cc === 32) &&
      !(cc === 180) &&
      !(cc === 38) &&
      !(cc === 8216) &&
      !(cc === 8217)
    ) {
      return false;
    }
  }
  return true;
};
